import { MantineThemeOverride } from '@mantine/core';

import colors from './tokens/colors/colors';
import { headings } from './tokens/typography/typography';

import ButtonDefaultConfig from './components/Button/config';
import ProgressDefaultConfig from './components/Progress/config';
import BadgeDefaultConfig from './components/Badge/config';
import TooltipDefaultConfig from './components/Tootlip/config';
import ListDefaultConfig from './components/List/config';
import CheckboxDefaultConfig from './components/Checkbox/config';
import NotificationDefaultConfig from './components/Notification/config';
import SelectDefaultConfig from './components/Select/config';
import MultiSelectDefaultConfig from './components/MultiSelect/config';
import ModalDefaultConfig from './components/Modal/config';
import SwitchDefaultConfig from './components/Switch/config';
import MenuDefaultConfig from './components/Menu/config';
import TitleDefaultConfig from './components/Title/config';
import FileInputDefaultConfig from './components/FileInput/config';
import InputDefaultConfig from './components/Input/config';

export default {
	// Colors
	colors,
	primaryColor: 'blue',
	primaryShade: 5,

	// Fonts
	fontFamily: 'Open Sans, sans-serif',
	components: {
		Button: ButtonDefaultConfig,
		Progress: ProgressDefaultConfig,
		Badge: BadgeDefaultConfig,
		Tooltip: TooltipDefaultConfig,
		List: ListDefaultConfig,
		Checkbox: CheckboxDefaultConfig,
		Notification: NotificationDefaultConfig,
		Select: SelectDefaultConfig,
		MultiSelect: MultiSelectDefaultConfig,
		Modal: ModalDefaultConfig,
		Switch: SwitchDefaultConfig,
		Menu: MenuDefaultConfig,
		Title: TitleDefaultConfig,
		FileInput: FileInputDefaultConfig,
		Input: InputDefaultConfig
	},

	// Headings
	headings: {
		fontFamily: 'Open Sans, sans-serif',
		sizes: headings
	}
} as MantineThemeOverride;
